import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './modules/shared/home/home.component';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'data-visualisation',
        loadChildren: () => import('./modules/data-visualisation/data-visualisation.module').then(m => m.DataVisualisationModule)
      },
      {
        path: 'data-parameters',
        loadChildren: () => import('./modules/data-parameters/data-parameters.module').then(m => m.DataParametersModule)
      },
      {
        path: 'settings',
        loadChildren: () => import('./modules/settings/settings.module').then(m => m.SettingsModule)
      },
      { path: '', redirectTo: '', pathMatch: 'full' },
      { path: 'home', component: HomeComponent },
    ]
  },
]
@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }